import { render, staticRenderFns } from "./AdminRealEstateDevelopmentEditView.vue?vue&type=template&id=37b31142"
import script from "./AdminRealEstateDevelopmentEditView.vue?vue&type=script&lang=js"
export * from "./AdminRealEstateDevelopmentEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports